<template>
    <div v-if="show">
        <el-form>
            <table width="100%">
                <tr v-for="(fixedPhrase, index) in inputFixedPhrase">
                    <td style="width:160px">
                        <el-form-item class="setting-items">
                            <el-select v-model="fixedPhrase.categoryValue" v-on:change="handleChangeCategory(fixedPhrase)" :placeholder="$t('message.place_holder_select_item')">
                                <el-option v-for="category in fixedPhraseItem.category" :key="category.value" :label="category.name" :value="category.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td style="padding-left:10px;height: 67px">
                        <el-form-item class="setting-items" :prop="fixedPhrase.name" :ref="fixedPhrase.name">
                            <div v-if="fixedPhrase.categoryValue === CONSTANT.FIXED_PHRASE_CATEGORY_SOUND">
                                <el-radio-group v-model="fixedPhrase.phraseValue">
                                    <span v-for="sound in fixedPhraseItem.soundType">
                                        <el-radio :label="sound.value"><span style="padding-right:10px">{{ sound.name }}</span></el-radio>
                                    </span>
                                </el-radio-group>
                            </div>
                            <div v-else>
                                <el-input :id="fixedPhrase.name" :placeholder="$t('message.place_holder_input_text')" v-model="fixedPhrase.phraseValue"
                                    @compositionstart.native="compositionStart(fixedPhrase)" @compositionend.native="compositionEnd(fixedPhrase)" @input.native="inputCheck(fixedPhrase)"
                                    clearable @clear="inputCheck(fixedPhrase)"/>
                            </div>
                        </el-form-item>
                    </td>
                    <td style="vertical-align:top;padding-top:3px;text-align:right;">
                        <el-select class="order-number-select" v-model="fixedPhrase.orderNumber" v-on:change="handleChangePhraseOrder(index + 1, fixedPhrase.orderNumber)">
                            <el-option v-for="orderNumber in fixedPhraseOrder" :key="orderNumber" :label="orderNumber" :value="orderNumber">
                            </el-option>
                        </el-select>
                        <button class="transparent-button" type="button" v-on:click="handleDeleteFixedPhrase(index)"><img src="../../../../assets/delete.svg"/></button>
                    </td>
                </tr>
                <tr>
                    <td style="width:160px;vertical-align:top">
                        <el-form-item class="setting-items" prop="addPhraseCategory" ref="addPhraseCategory">
                            <el-select v-model="addFixedPhrase.categoryValue" ref="vibeTypeOnNewTalker" v-on:change="handleChangeAddCategory()" :placeholder="$t('message.place_holder_select_item')" :disabled="isDisableToAdd()">
                                <el-option v-for="category in fixedPhraseItem.category" :key="category.value" :label="category.name" :value="category.value">
                                </el-option>
                                <el-option :key="CONSTANT.FIXED_PHRASE_CATEGORY_RESET" :label="CONSTANT.FIXED_PHRASE_RESET_TEXT" :value="CONSTANT.FIXED_PHRASE_CATEGORY_RESET"></el-option>
                            </el-select>
                        </el-form-item>
                    </td>
                    <td style="padding-left:10px;vertical-align:top">
                        <el-form-item prop="addPhraseValue" ref="addPhraseValue">
                            <div v-if="addFixedPhrase.categoryValue === CONSTANT.FIXED_PHRASE_CATEGORY_SOUND">
                                <el-radio-group v-model="addFixedPhrase.phraseValue" @change="handleChangeSoundType">
                                    <span v-for="sound in fixedPhraseItem.soundType">
                                        <el-radio :label="sound.value"><span style="padding-right: 10px">{{ sound.name }}</span></el-radio>
                                    </span>
                                </el-radio-group>
                            </div>
                            <div v-else>
                                <el-input :placeholder="$t('message.place_holder_input_text')" type="textarea" :rows="1" v-model="addFixedPhrase.phraseValue" :disabled="isDisableToAdd() || (addFixedPhrase.categoryValue === null)"
                                          @compositionstart.native="compositionStartAddValue" @compositionend.native="compositionEndAddValue" @input.native="inputCheckAddValue()"
                                          clearable @clear="inputCheckAddValue()"/>
                            </div>
                        </el-form-item>
                    </td>
                    <td style="vertical-align:top;text-align:right">
                        <span v-if="isDisableToAdd()">
                            <el-tooltip effect="dark" placement="top-start">
                                <div v-if="!enableSwitchValue" slot="content" style="text-align:left" v-t="'message.info_fixed_phrase_is_disabled'"></div>
                                <div v-else slot="content" style="text-align:left" v-t="'message.info_fixed_phrase_maximum_count'"></div>
                                <el-button class="disable-command-button" style="width:95px;padding-left:0px;padding-right:0px;text-align:center" v-t="'message.action_common_add'"></el-button>
                            </el-tooltip>
                        </span>
                        <span v-else>
                            <el-button class="enable-command-button" style="width:95px;padding-left:0px;padding-right:0px;text-align:center" v-on:click="handleAddFixedPhrase()" v-t="'message.action_common_add'" ></el-button>
                        </span>
                    </td>
                </tr>
            </table>
        </el-form>
    </div>
</template>

<script>
import commonUtil from '../../../commonutil.js';
import commonValidate from '../../../common-validate.js';
import constants from '../../../constants.js';

export default {
    data() {
        return {
            CONSTANT: {
                FIXED_PHRASE_CATEGORY_TEXT: constants.FIXED_PHRASE_CATEGORY_TEXT,
                FIXED_PHRASE_CATEGORY_SOUND: constants.FIXED_PHRASE_CATEGORY_SOUND,
                FIXED_PHRASE_CATEGORY_MELODY: constants.FIXED_PHRASE_CATEGORY_MELODY,
                FIXED_PHRASE_CATEGORY_RESET: constants.FIXED_PHRASE_CATEGORY_RESET,
                FIXED_PHRASE_RESET_TEXT: commonUtil.getMessageText(this.$i18n, "action_reset")
            },
            addFixedPhrase: {
                categoryValue: null,
                phraseValue: null,
                isComposing: false,
                valid: true,
                progress: false
            },
            inputFixedPhrase: [],
            fixedPhraseOrder: [],
            show: true,
        };
    },
    methods: {
        handleAddFixedPhrase() {
            if (this.addFixedPhrase.categoryValue === constants.FIXED_PHRASE_CATEGORY_MELODY) {
                let validateResult = commonValidate.validateItem(this.$i18n, "melodyStamp", this.addFixedPhrase.phraseValue);
                if (validateResult.valid) {
                    this.addFixedPhrase.valid = true;
                    this.$refs["addPhraseValue"].clearValidate();
                } else {
                    this.addFixedPhrase.valid = false;
                    this.$refs["addPhraseValue"].validateState = "error";
                    this.$refs["addPhraseValue"].validateMessage = validateResult.message;
                }
            }
            if (!this.addFixedPhrase.valid || this.addFixedPhrase.categoryValue == null) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_fixed_phrase"));
                return;
            }
            if (!this.addFixedPhrase.valid) {
                this.inputCheckAddCategory();
                this.inputCheckAddValue();
                return;
            }
            this.$refs["addPhraseValue"].clearValidate();
            this.inputFixedPhrase.push({ name: "fixedPhrase" + (this.inputFixedPhrase.length + 1), orderNumber: this.inputFixedPhrase.length + 1, categoryValue:this.addFixedPhrase.categoryValue, phraseValue:this.addFixedPhrase.phraseValue, isComposing:false, valid:true, editMelodyStamp:false });
            this.addFixedPhrase.categoryValue = null;
            this.addFixedPhrase.phraseValue = null;
            this.fixedPhraseOrder.push(this.inputFixedPhrase.length);
            this.addFixedPhrase.valid = true;
            this.addFixedPhrase.progress = false;
            this.setValidStatus();
        },
        handleChangeAddCategory() {
            if (this.addFixedPhrase.categoryValue === constants.FIXED_PHRASE_CATEGORY_SOUND) {
                this.$refs["addPhraseValue"].clearValidate();
                this.addFixedPhrase.phraseValue = 1;
                this.addFixedPhrase.valid = true;
                this.addFixedPhrase.progress = true;
                this.inputCheckAddValue();
            } else {
                this.$refs["addPhraseValue"].clearValidate();
                this.addFixedPhrase.phraseValue = null;
                this.addFixedPhrase.valid = false;
                if (this.addFixedPhrase.categoryValue === constants.FIXED_PHRASE_CATEGORY_RESET) {
                    this.addFixedPhrase.categoryValue = null;
                    this.addFixedPhrase.phraseValue = null;
                    this.addFixedPhrase.valid = true;
                    this.setValidStatus();
                    this.addFixedPhrase.progress = false;
                    return;
                } else {
                    this.addFixedPhrase.progress = true;
                }
                this.inputCheckAddValue();
            }
        },
        handleChangeCategory(fixedPhrase) {
            if (fixedPhrase.categoryValue === constants.FIXED_PHRASE_CATEGORY_SOUND) {
                fixedPhrase.phraseValue = 1;
            } else {
                if (fixedPhrase.categoryValue === constants.FIXED_PHRASE_CATEGORY_MELODY) {
                    fixedPhrase.editMelodyStamp = true;
                }
                fixedPhrase.phraseValue = null;
            }
            this.inputCheck(fixedPhrase);
        },
        handleChangeSoundType() {
            this.setValidStatus();
        },
        handleChangePhraseOrder(oldOrderNumber, newOrderNumber) {
            if ((!this.inputFixedPhrase[oldOrderNumber-1].valid) || (!this.inputFixedPhrase[newOrderNumber-1].valid)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n, "error_cannot_change_fixed_phrase_order"));
                this.inputFixedPhrase[oldOrderNumber-1].orderNumber = oldOrderNumber;
                return;
            }
            let saveFixedPhrase = this.inputFixedPhrase[oldOrderNumber - 1];
            this.inputFixedPhrase.splice(oldOrderNumber - 1 , 1);
            this.inputFixedPhrase.splice(newOrderNumber - 1 , 0, saveFixedPhrase);
            for (let index = 0 ; index < this.inputFixedPhrase.length ; index ++) {
                this.inputFixedPhrase[index].orderNumber = index + 1;
                this.inputFixedPhrase[index].name = this.fixedPhraseName + "-" + String(index + 1);
            }
            this.reDrawFixedPhraseList();
            this.setValidStatus();
        },
        handleDeleteFixedPhrase(index) {
            this.inputFixedPhrase.splice(index, 1);
            this.fixedPhraseOrder.splice(index, 1);
            this.fixedPhraseOrder = [];
            for (let index = 0 ; index < this.inputFixedPhrase.length ; index ++) {
                this.inputFixedPhrase[index].orderNumber = index + 1;
                this.fixedPhraseOrder.push(index + 1);
            }
            this.setValidStatus();
        },
        isDisableToAdd() {
            if (this.enableSwitchValue) {
                return (this.inputFixedPhrase.length >= 5);
            } else {
                return true;
            }
        },
        compositionStart(fixedPhrase) {
            fixedPhrase.isComposing = true;
        },
        compositionEnd(fixedPhrase) {
            fixedPhrase.isComposing = false;
            this.inputCheck(fixedPhrase)
        },
        compositionStartAddValue() {
            this.addFixedPhrase.isComposing = true;
        },
        compositionEndAddValue() {
            this.addFixedPhrase.isComposing = false;
            this.inputCheckAddValue();
        },
        inputCheck(fixedPhrase) {
            if (fixedPhrase.isComposing) {
                // inputting with IME
                return;
            }
            let validationRule;
            switch(fixedPhrase.categoryValue) {
                case constants.FIXED_PHRASE_CATEGORY_TEXT:
                    validationRule = "reqText200";
                    break;
                case constants.FIXED_PHRASE_CATEGORY_SOUND:
                    validationRule = "selectItem";
                    break;
                case constants.FIXED_PHRASE_CATEGORY_MELODY:
                    if (fixedPhrase.phraseValue === "") {
                        fixedPhrase.valid = false;
                        this.$refs[fixedPhrase.name][0].validateState = "error";
                        this.$refs[fixedPhrase.name][0].validateMessage = commonUtil.getMessageText(this.$i18n, "error_validate_not_found");
                    } else {
                        if (!fixedPhrase.valid) {
                            fixedPhrase.valid = true;
                            this.$refs[fixedPhrase.name][0].clearValidate();
                        }
                    }
                    fixedPhrase.editMelodyStamp = true;
                    this.setValidStatus();
                    return;
            }
//            if ((typeof this.$refs[fixedPhrase.name] === "undefined") || (this.$refs[fixedPhrase.name].length === 0)) {
//                // form-item will be changed by category change , but not complete the mount on this timing.
//                return;
//            }

            let validateResult = commonValidate.validateItem(this.$i18n, validationRule, fixedPhrase.phraseValue);
            if (validateResult.valid) {
                fixedPhrase.valid = true;
                this.$refs[fixedPhrase.name][0].clearValidate();
            } else {
                fixedPhrase.valid = false;
                this.$refs[fixedPhrase.name][0].validateState = "error";
                this.$refs[fixedPhrase.name][0].validateMessage = validateResult.message;
            }
//            if (this.$refs[fixedPhrase.name][0].validateState === "error") {
//                this.addFixedPhrase.valid = false;
//            } else {
//                this.addFixedPhrase.valid = true;
//            }
            this.setValidStatus();
        },
        inputCheckAddCategory() {
            let validateResult;
            validateResult = commonValidate.validateItem(this.$i18n, "selectItem", this.addFixedPhrase.categoryValue);
            if (validateResult.valid) {
                this.$refs["addPhraseCategory"].clearValidate();
            } else {
                this.$refs["addPhraseCategory"].validateState = "error";
                this.$refs["addPhraseCategory"].validateMessage = validateResult.message;
            }
        },
        inputCheckAddValue() {
            this.addFixedPhrase.progress = true;
            if (this.addFixedPhrase.isComposing) {
                // inputting with IME
                return;
            }
//            if ((typeof this.$refs["addPhraseValue"] === "undefined") || (this.$refs["addPhraseValue"].length === 0)) {
//                // form-item will be changed by category change , but not complete the mount on this timing.
//                return;
//            }
            let validateResult = {};
            switch(this.addFixedPhrase.categoryValue) {
                case constants.FIXED_PHRASE_CATEGORY_TEXT:
                    validateResult = commonValidate.validateItem(this.$i18n, "reqText200", this.addFixedPhrase.phraseValue);
                    break;
                case constants.FIXED_PHRASE_CATEGORY_SOUND:
                    this.addFixedPhrase.valid = true;
                    validateResult.valid = true;
                    break;
                case constants.FIXED_PHRASE_CATEGORY_MELODY:
                    if (this.addFixedPhrase.phraseValue === null) {
                        validateResult.valid = false;
                        validateResult.message = commonUtil.getMessageText(this.$i18n, "error_validate_not_found");
                    } else {
                        this.addFixedPhrase.valid = true;
                        validateResult.valid = true;
                    }
                    break;
                case constants.FIXED_PHRASE_CATEGORY_RESET:
                    this.addFixedPhrase.valid = true;
                    this.addFixedPhrase.progress = false;
                    this.$refs["addPhraseValue"].clearValidate()
                    this.setValidStatus();
                    return;
            }

            if (validateResult.valid) {
                this.addFixedPhrase.valid = true;
                this.$refs["addPhraseValue"].validateMessage = commonUtil.getMessageText(this.$i18n, "error_add_fixed_phrase");
            } else {
                this.addFixedPhrase.valid = false;
                this.$refs["addPhraseValue"].validateMessage = validateResult.message;
            }
            this.$refs["addPhraseValue"].validateState = "error";
            this.setValidStatus();
        },
        inputCheckMelodyStamp(fixedPhrase) {
            // this function use by editClientSetting component at save time.
            let validateResult = commonValidate.validateItem(this.$i18n, "melodyStamp", fixedPhrase.phraseValue);
            if (validateResult.valid) {
                fixedPhrase.valid = true;
                this.$refs[fixedPhrase.name][0].clearValidate();
            } else {
                fixedPhrase.valid = false;
                this.$refs[fixedPhrase.name][0].validateState = "error";
                this.$refs[fixedPhrase.name][0].validateMessage = validateResult.message;
            }
            this.setValidStatus();
        },
        setValidStatus() {
            let param = {name: this.fixedPhraseName, validStatus: true};
            for (let fixedPhrase of this.inputFixedPhrase) {
                if (!fixedPhrase.valid) {
                    param.validStatus = false;
                }
            }
            if (param.validStatus) {
                if (this.addFixedPhrase.valid) {
                    if (this.addFixedPhrase.progress) {
                        param.validStatus = false;
                    } else {
                        param.validStatus = true;
                    }
                } else {
                    param.validStatus = false;
                }
            }
            this.$emit("setSaveButtonStatus", param);
        },
        isAddingPhraseComplete() {
            return (this.addFixedPhrase.categoryValue == null) || (this.addFixedPhrase.phraseValue == null);
        },
        reDrawFixedPhraseList() {
            this.show = false;
            this.$nextTick(() => {
                this.show = true
            })
        }
    },
    components: {
    },
    created: function() {
        if (this.fixedPhraseValue != null) {
            let index = 1;
            for (let fixedPhrase of this.fixedPhraseValue) {
                this.inputFixedPhrase.push({name: this.fixedPhraseName + "-" + String(index), categoryValue: fixedPhrase.categoryValue, phraseValue: fixedPhrase.phraseValue, orderNumber: index, isComposing:false, valid: true, editMelodyStamp: false})
                this.fixedPhraseOrder.push(index);
                index++;
            }
        }
    },
    mounted: function() {
    },
    watch: {
        enableSwitchValue(newVal) {
            if (newVal) {
                this.addFixedPhrase.categoryValue = this.CONSTANT.FIXED_PHRASE_CATEGORY_TEXT;
                this.inputCheckAddValue();
            } else {
                if ((this.addFixedPhrase.categoryValue === constants.FIXED_PHRASE_CATEGORY_TEXT) || (this.addFixedPhrase.categoryValue === constants.FIXED_PHRASE_CATEGORY_MELODY)) {
                    this.$refs["addPhraseValue"].clearValidate();
                }
                this.inputFixedPhrase = [];
                this.addFixedPhrase.categoryValue = null;
                this.addFixedPhrase.phraseValue = null;
            }
        },
    },
    props: [ 'fixedPhraseItem' , 'fixedPhraseName' , 'fixedPhraseValue' , 'enableSwitchValue' ]
}

</script scoped>
<style>
.el-textarea__inner {
    height: 40px;
    padding-top: 9px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-textarea__inner {
    height: 40px;
    padding-top: 9px;
}
.order-number-select {
    width: 55px;
}
</style>
